import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import * as FileSaver from "file-saver";

import {
  RouterLinkRenderer,
  DatepickerEditor,
  ViewService,
  SearchParams,
  ItemService,
  Item,
} from "../../common";
import { DatePipe } from "@angular/common";

@Component({
  selector: "item-list-view",
  templateUrl: "./item-list.component.html",
  styleUrls: ["./item-list.component.css"],
  standalone: false,
})
export class ItemListView implements OnInit {
  searchCriteria: string;
  actions: any[];

  private gridApi;
  private gridColumnApi;
  public columnDefs;
  public defaultColDef;
  public components;
  public frameworkComponents;
  public editType;
  item: Item;
  approvalCanceled: boolean = false;

  constructor(public viewService: ViewService, public itemService: ItemService) {
    viewService.setViewData({
      pageTitle: "Items",
      link: { text: "» New", routeData: ["/items/new"] },
      breadcrumbs: false,
    });

    this.initManifestGrid();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  navigate(params: any): void {
    this.viewService.router.navigate(["/items", params]);
  }

  onCellValueChanged(event) {
    if (event.newValue !== event.oldValue) {
      if (!event.node.changedValues) event.node.changedValues = [];

      event.node.changedValues.push(event.colDef.field);
    }
  }

  onRowValueChanged(event) {
    if (event.node.changedValues) {
      console.log(`Changed Values = ${event.node.changedValues.join(",")}`);
      this.save(event.data);
      event.node.changedValues = null;
    }
  }

  performSearch(searchParams: SearchParams): Observable<Item[]> {
    this.searchCriteria = searchParams.search;
    console.log(searchParams);
    return this.itemService.filterBy(searchParams);
  }
  exportList() {
    const datepipe: DatePipe = new DatePipe("en-US");
    let formattedDate = datepipe.transform(new Date(), "YYYYMMddHHmmss");
    let searchParams = { search: this.searchCriteria } as SearchParams;

    return this.itemService.exportList(searchParams).subscribe(
      (resp) => {
        FileSaver.saveAs(resp, `WIMS-ITEMS-${formattedDate}.xlsx`);
      },
      async (error) => {
        const message = JSON.parse(await error.error.text()).message;
        console.log(message);
      }
    );
  }
  onRowSelected(event) {
    if (event.node.selected) {
      this.item = event.node.data;
      console.log(this.item);
    }
  }

  save(item: Item) {
    this.itemService.save(item).subscribe(
      (man) => {
        console.log(man);
      },
      (error) => console.log(error)
    );
  }

  ngOnInit(): void {
    console.log("init listview");
  }
  onFirstDataRendered() {
    let allColumnIds = [];
    this.gridApi.getColumns().forEach(function (column) {
      allColumnIds.push(column.getColId());
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds, true);
  }
  initManifestGrid() {
    this.editType = "fullRow";
    this.frameworkComponents = {
      datePicker: DatepickerEditor,
      btnCellRenderer: RouterLinkRenderer,
    };
    this.columnDefs = [
      {
        headerName: "Edit",
        field: "itemNumber",
        cellRenderer: "btnCellRenderer",
        minWidth: 120,
        maxWidth: 120,
        pinned: "left",
        sortable: false,
        filter: false,
        floatingFilter: true,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        editable: false,
      },
      {
        headerName: "ITM No",
        field: "itemNumber",
        minWidth: 100,
        maxWidth: 120,
        pinned: "left",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "CTN No",
        field: "containerNumber",
        editable: false,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Detail",
        field: "itemDetail",
        minWidth: 150,
        editable: false,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Description",
        field: "description",
        minWidth: 200,
        editable: false,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Type",
        field: "wasteType",
        minWidth: 120,
        editable: false,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Owner Name",
        field: "ownerName",
        minWidth: 200,
        editable: false,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Stream Name",
        field: "streamName",
        minWidth: 200,
        editable: false,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Start Date",
        field: "pickupDate",
        minWidth: 120,
        filter: "agDateColumnFilter",
        sortingOrder: ["asc", "desc"],
        cellEditor: "datePicker",
        cellRenderer: (data) => {
          return data.value ? new Date(data.value).toLocaleDateString() : "";
        },
      },
      {
        headerName: "Quantity",
        field: "numberOfItems",
        minWidth: 100,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Volume",
        field: "volumeUn",
        minWidth: 100,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Weight",
        field: "weightUn",
        minWidth: 100,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "State",
        field: "physicalState",
        minWidth: 100,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "RCRA",
        field: "labPackRcra",
        minWidth: 90,
        sortingOrder: ["asc", "desc"],
        cellEditor: "select",
        cellEditorParams: { values: boolbranding },
        refData: boolMapping,
      },
      {
        headerName: "Tracking No",
        field: "trackingNumber",
        minWidth: 120,
        editable: false,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
    ];
    this.defaultColDef = {
      flex: 1,
      wrapText: true,
      minWidth: 100,
      resizable: true,
      sortable: true,
      floatingFilter: true,
      filter: true,
      autoHeight: true,
      editable: true,
    };
  }
}
let boolMapping = {
  true: "Yes",
  false: "No",
};

let boolbranding = extractValues(boolMapping);
function extractValues(mappings) {
  return Object.keys(mappings);
}
